<form [formGroup]="branchloginMasterFrom">
    <div class="auth-wrapper">
      <div class="auth-content">
        <div class="card">
          <div class="row align-items-center text-center">
            <div class="col-md-12">
              <div class="card-body">
                <img src="assets/images/auth/auth-logo-dark.png" alt="" class="img-fluid mb-4">
                <h4 class="mb-3 f-w-400">Select Branch</h4>
             


                <div class="form-group mb-3">
                    <div class="form-group">
                        <select class="form-control" formControlName="branchId" [(ngModel)]="branchId">
                            <option disabled value="">--Select Branch--</option>
                            <option *ngFor="let obj of branchList" value={{obj.branchId}}>
                              {{obj.branchName}}</option>
                        </select>
                        <div *ngIf="submitted && Validation.branchId.errors?.required" class="red">
                          Please Enter Branch
                      </div>
                    </div>
                </div>

                <div class="row">
                  <div class="mt-3 col-md-12">
                      <button type="button" class="btn btn-success mr-2 button form-group col-md-12" ngbTooltip="btn-success"
                          (click)="submit()">Submit</button>
                  </div>
              </div>
             
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>